import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroSection from '@/pages/home/components/HeroSection';
import TickerBar from '@/pages/home/components/TickerBar';
import HotspotGrid from '@/pages/home/components/HotspotGrid';
import OnsiteFeed from '@/pages/home/components/OnsiteFeed';
import GuideSteps from '@/pages/home/components/GuideSteps';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeBand from '@/pages/home/components/SubscribeBand';
import useReveal from '@/hooks/useReveal';

export default function Home() {
  useReveal();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <TickerBar />
        <HotspotGrid />
        <OnsiteFeed />
        <GuideSteps />
        <FaqSection />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}